module.exports = __webpack_public_path__ + "assets/img/a905aa1e333c1822cd5ebd69f6346531.png";